import gql from "graphql-tag"

export default gql`
  query searchMovie($text: String!) {
    search: tmdbSearchMovie(text: $text)
  }
`